type ScrollMainBehavior = "smooth" | "auto";

/** Scroll the app layout's main scroll-region so `elementId` sits under its scroll-margin. */
export function scrollMainToId(elementId: string, behavior: ScrollMainBehavior = "smooth") {
  const main = document.querySelector("main[scroll-region]");
  const target = document.getElementById(elementId);
  if (!(main instanceof HTMLElement) || !target) {
    return;
  }

  const scrollMarginTop = Number.parseFloat(getComputedStyle(target).scrollMarginTop) || 0;
  const top = main.scrollTop + target.getBoundingClientRect().top - main.getBoundingClientRect().top - scrollMarginTop;
  main.scrollTo({ top: Math.max(top, 0), behavior });
}
